import React, { useState } from 'react';
import metalCardImg from '../../../../images/Web/Metal Sound/metal-card4x-min.webp';
import playSoundIcon from '../../../../Icons/icon-sound.svg';
import upArrowIcon from '../../../../Icons/icon-arrow-up.svg';
import downArrowIcon from '../../../../Icons/icon-arrow-down.svg';
import { faqObjects } from './Data';

function FaqAndSound() {
  const playAudio = () => {
    const path =
      'https://www.getonecard.app/assets/apply/oc-dropping.mp3';
    const audio = new Audio(path);
    audio.play();
  };
  const [visibleAnswers, setVisibleAnswers] = useState<number[]>([]);

  const toggleAnswerVisibility = (index: number) => {
    if (visibleAnswers.includes(index)) {
      setVisibleAnswers(visibleAnswers.filter((i) => i !== index)); // if answer is already visible and the toggle arrow is clicked, then the answer is removed from the visibleAnswers array, and the answer vanishes
    } else {
      setVisibleAnswers([...visibleAnswers, index]);
    }
  };
  return (
    <>
      <div className="metal-card-clink mt-44 flex flex-col items-center mobile:mt-28">
        <div className="card-image">
          <img
            src={metalCardImg}
            className="scale-120"
            alt="metal card"
          />
        </div>
        <div
          className="metal-clink-audio-container border-white border-opacity-60 opacity-60 hover:opacity-100 transition-opacity hover:border-gray-100 border-2 flex justify-center font-manrope font-normal text-sm leading-6 tracking-wide text-white mt-12 max-w-max py-3 px-6 rounded-xl cursor-pointer"
          role="button"
          tabIndex={0}
          onClick={playAudio}
          onKeyDown={playAudio}
        >
          <img src={playSoundIcon} className="" alt="" />
          <p className="pl-2">Hear the 16 Gram Metal Clink</p>
        </div>
      </div>

      <div className="FAQ-container mt-48 mb-96 max-h-96 w-3/4 m-auto p-x flex flex-col items-center mobile:mt-32 mobile:mb-64 mobile:w-full">
        <div className="FAQ-heading m-auto font-manrope font-semibold text-4xl leading-11 text-center tracking-tight text-white mb-20">
          Frequently Asked Questions
        </div>

        {faqObjects.map((obj, index) => {
          return (
            <div
              className="question-card-container flex flex-col w-4/5"
              key={obj.question}
            >
              <div className="question-card flex flex-col justify-center p-5 tracking-wide bg-0D0D0D rounded-xl font-manrope text-sm mt-3">
                <div className="question-and-arrow-container flex justify-between w-full">
                  <div className="question opacity-90">
                    {obj.question}
                  </div>
                  <button
                    type="button"
                    className="arrow"
                    onClick={() => toggleAnswerVisibility(index)}
                  >
                    <img
                      src={
                        visibleAnswers.includes(index)
                          ? upArrowIcon
                          : downArrowIcon
                      }
                      alt=""
                    />
                  </button>
                </div>
                {visibleAnswers.includes(index) && (
                  <div className="answer opacity-60 bg-0D0D0D">
                    {obj.answer}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default FaqAndSound;
